/* eslint-disable jsx-a11y/anchor-is-valid */
import IconQuote from "../../assets/images/icon-quote.svg";

import { useEffect } from "react";
import "./About.css";
import { LazyLoadImage } from "react-lazy-load-image-component";
import SkeletonAbout from "../../Components/Pages/About/SkeletonAbout";
import Skeleton from "react-loading-skeleton";

const About = ({ aboutData, aboutLoading, aboutError }) => {
  useEffect(() => {
    const testimonialsItem = document.querySelectorAll(
      "[data-testimonials-item]"
    );
    const modalContainer = document.querySelector("[data-modal-container]");
    const overlay = document.querySelector("[data-overlay]");
    const modalImg = document.querySelector("[data-modal-img]");
    const modalTitle = document.querySelector("[data-modal-title]");
    const modalText = document.querySelector("[data-modal-text]");
    const modalTime = document.querySelector("[data-modal-time]");
    const modalCloseBtn = document.querySelector("[data-modal-close-btn]");

    if (!modalContainer || !overlay || !modalCloseBtn) return; // 🔥 مهم جداً

    const testimonialsModalFunc = function () {
      modalContainer.classList.toggle("active");
      overlay.classList.toggle("active");
    };

    for (let i = 0; i < testimonialsItem.length; i++) {
      testimonialsItem[i].addEventListener("click", function () {
        modalImg.src = this.querySelector("[data-testimonials-avatar]").src;
        modalImg.alt = this.querySelector("[data-testimonials-avatar]").alt;
        modalTitle.innerHTML = this.querySelector(
          "[data-testimonials-title]"
        ).innerHTML;

        modalTime.innerHTML = this.querySelector(
          "[data-testimonials-time]"
        ).innerHTML;

        modalText.innerHTML = this.querySelector(
          "[data-testimonials-text]"
        ).innerHTML;

        testimonialsModalFunc();
      });
    }

    modalCloseBtn.addEventListener("click", testimonialsModalFunc);
    overlay.addEventListener("click", testimonialsModalFunc);

    // تنظيف عند الخروج
    return () => {
      modalCloseBtn.removeEventListener("click", testimonialsModalFunc);
      overlay.removeEventListener("click", testimonialsModalFunc);
    };
  }, [aboutLoading]);

  return (
    <>
      {/* #ABOUT */}
      <article className="about  active" data-page="about">
        <header>
          <h2 className="h2 article-title">
            {aboutLoading
              ? <Skeleton width={180} height={27} />
              : aboutError
              ? "Error"
              : aboutData?.about?.title || "No data"}
          </h2>
        </header>

        {/* حالة التحميل */}
        {aboutLoading ? (
          <SkeletonAbout />
        ) : (
          <>
            <section className="about-text">
              {aboutData.about.aboutText.map((paragraph, idx) => (
                <p key={idx}>{paragraph}</p>
              ))}
            </section>

            {/* service */}
            <section className="service">
              <h3 className="h3 service-title">What i'm doing</h3>
              <ul className="service-list">
                {aboutData.services.map((service, idx) => (
                  <li className="service-item" key={idx}>
                    <div className="service-icon-box">
                      <LazyLoadImage
                        src={service.icon}
                        alt={service.title}
                        width="40"
                      />
                    </div>
                    <div className="service-content-box">
                      <h4 className="h4 service-item-title">{service.title}</h4>
                      <p className="service-item-text">{service.description}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </section>

            {/* testimonials */}
            <section className="testimonials">
              <h3 className="h3 testimonials-title">Testimonials</h3>
              <ul className="testimonials-list has-scrollbar">
                {aboutData.testimonials.map((testimonial, idx) => (
                  <li className="testimonials-item" key={idx}>
                    <div className="content-card" data-testimonials-item>
                      <figure className="testimonials-avatar-box">
                        <LazyLoadImage
                          src={testimonial.avatar}
                          alt={testimonial.name}
                          width="60"
                          data-testimonials-avatar
                        />
                      </figure>
                      <h4
                        className="h4 testimonials-item-title"
                        data-testimonials-title
                      >
                        {testimonial.name}
                      </h4>
                      <time
                        dateTime={testimonial.date}
                        data-testimonials-time
                        style={{ display: "none" }}
                      >
                        {testimonial.date}
                      </time>
                      <div className="testimonials-text" data-testimonials-text>
                        <p>{testimonial.feedback}</p>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </section>

            {/* testimonials modal */}
            <div className="modal-container" data-modal-container>
              <div className="overlay" data-overlay></div>
              <section className="testimonials-modal">
                <button className="modal-close-btn" data-modal-close-btn>
                  <ion-icon name="close-outline"></ion-icon>
                </button>
                <div className="modal-img-wrapper">
                  <figure className="modal-avatar-box">
                    <img src="" alt="Daniel lewis" width="80" data-modal-img />
                  </figure>
                  <img src={IconQuote} alt="quote icon" />
                </div>
                <div className="modal-content">
                  <h4 className="h3 modal-title" data-modal-title>
                    Daniel lewis
                  </h4>
                  <time dateTime="2021-06-14" data-modal-time>
                    14 June, 2021
                  </time>
                  <div data-modal-text>
                    <p>
                      Richard was hired to create a corporate identity. We were
                      very pleased with the work done. She has a lot of
                      experience and is very concerned about the needs of
                      client. Lorem ipsum dolor sit amet, ullamcous cididt
                      consectetur adipiscing elit, seds do et eiusmod tempor
                      incididunt ut laborels dolore magnarels alia.
                    </p>
                  </div>
                </div>
              </section>
            </div>

            {/* clients */}
            <section className="clients">
              <h3 className="h3 clients-title">Clients</h3>
              <ul className="clients-list has-scrollbar">
                {aboutData.clients.map((client, idx) => (
                  <li className="clients-item" key={idx}>
                    <a href={client.url || "#"}>
                      <LazyLoadImage src={client.logo} alt={client.name} />
                    </a>
                  </li>
                ))}
              </ul>
            </section>
          </>
        )}

        {/* حالة الخطأ */}
        {aboutError && <p style={{ color: "red" }}>{aboutError}</p>}

        {/* حالة عدم وجود بيانات */}
        {!aboutLoading && !aboutError && !aboutData?.about && (
          <p>No data available.</p>
        )}
      </article>
    </>
  );
};

export default About;
